import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    backgroundColor: '#B71540',
    '&:hover': {
      backgroundColor: '#85144b',
    },
  },
  label: {
    color: '#FFFFFF',
    textTransform: 'uppercase',
    fontSize: '14pt',
  },
}));

interface ButtonProps {
  children: any;
  type?: any;
  [x: string]: any;
}

const SecondaryButton = (props: ButtonProps) => {
  const { children, ...other } = props;
  const classes = useStyles();

  return (
    <Button
      classes={{
        root: classes.root, // class name, e.g. `classes-nesting-root-x`
        label: classes.label, // class name, e.g. `classes-nesting-label-x`
      }}
      {...other}
    >
      {children || ''}
    </Button>
  );
};

export default SecondaryButton;
